exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product {\n  position: relative;\n}\n.product-image {\n  max-height: unset !important;\n}\n", ""]);

// exports
